import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { DoctorService } from '../../_service/doctor.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
import { LeadsService } from '../../_service/leads.service';
import {formatDate} from '@angular/common';
import { MiscService } from '../../_service/misc.service';
import {ConfirmationModalComponent} from '../../common/confirmation-modal/confirmation-modal.component';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { SafePipe } from '../../_pipes/safe.pipe';

declare var $: any;
import * as XLSX from 'xlsx';
import { identifierModuleUrl } from '@angular/compiler';
@Component({
  selector: 'app-doctor',
  templateUrl: './doctor.component.html',
  styleUrls: ['./doctor.component.css']
})
export class DoctorComponent implements OnInit {

    @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('csvDoctorRankingFieldUpdate', {static: false}) csvDoctorRankingFieldUpdate: ElementRef;
    @ViewChild('csvUpload', { static: false }) csvUpload: ElementRef;
    perpage:number=25;doctorsList:any=[];length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;
    pageSizeOptions = [10,25,50,100];pageIndex:number=0;loaded:boolean=false;cities=[];city='';circles=[];circle='';
    search:string;sc3Url='';status='';circles_copy=[];treatCategory=[];treatment_category_filter='';zone=''
    submitted:boolean=false;uploaded_msg: string = '';userId:string;
    constructor(private doctorapi:DoctorService,private sharedapi:SharedService,public leadapi:LeadsService,private dialog: MatDialog,public miscapi:MiscService) {

    }

    updateDoctorOrder(order,id){
        let UpdateData ={
            'id':id,
            'order_id':order
        }

        this.doctorapi.updateDoctorOrder(UpdateData)
        .subscribe((data:any) => {
        if(data.status)
        {
            this.sharedapi.presentToast('Order Update Successfully');
        }
        else
        {
            this.sharedapi.presentToast(data.msg);
        }
        }, error =>
        {
            this.sharedapi.checkError(error);
        });
    }

    ngOnInit(): void
    {
        this.getcircle();
        this.getTreatmentCategory();
        this.sharedapi.getRole()
        .subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');
        this.sc3Url = localStorage.getItem('s3url');
        this.userId = localStorage.getItem('loginuserId');
    }

    async getTreatmentCategory()
    {
        await this.miscapi.getTreat_Category().subscribe((data:any) => {
            if(data.status)
            {
                this.treatCategory = data.data;
            }else{
                this.treatCategory = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    getCatergoryName(treatCategory){
        if(treatCategory!=null){
            var splittedStringArray = treatCategory.split(",");
            let TreatcatName='';
            splittedStringArray.forEach(element => {
                TreatcatName += '<span class="circleNamestyle">' + element + '</span>';
            });
            return TreatcatName;
        }

    }

    showOnLP(event,id,index){
        let status;
        if(event.checked){
            status=1;
        }else{
            status=0;
        }
        let value = {
            'id':id,
            'display_on_LP':status
        }
        this.doctorapi.showingOnLP(value)
        .subscribe((data:any) => {
            if(data.status)
            {
                this.sharedapi.presentToast('Data Updated Successfully');
                this.doctorsList[index].display_on_LP=data.data.display_on_LP;
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
        }, error =>
        {
            this.sharedapi.checkError(error);
        });

    }

    onStatusChange(event,id,index){
        let status;
        if(event.checked){
            status=1;
        }else{
            status=0;
        }
        let value = {
            'id':id,
            'status':status
        }
        this.doctorapi.updateDoctorStatus(value)
        .subscribe((data:any) => {
            if(data.status)
            {
                this.sharedapi.presentToast('Status Update Successfully');
                this.doctorsList[index].status=data.data.status;
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
        }, error =>
        {
            this.sharedapi.checkError(error);
        });

    }

    setSearchValue(){
        $("#circleSearch").val('');
        $("#circleSearch").focus();
        this.circles= this.circles_copy;
    }

    searchOnSelect(searchtText: string, type){
        if (type == 'circle') {
            this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
        }
    }

    ngAfterViewInit() {
         this.loadDoctorsList(0,this.perpage);
    }

    async loadDoctorsList(pageIndex,perpage)
    {
        this.doctorsList = [];
        this.paginatorBottom.pageIndex = pageIndex;
        this.pageIndex = pageIndex;
        this.paginator.pageIndex = pageIndex;
        let qString = 'search='+this.search+'&circle='+this.circle+'&status='+this.status+'&treatment_category_filter='+this.treatment_category_filter+'&zone='+this.zone;
        this.loading = true;this.loaded = false;
        await this.doctorapi.getDoctorList(this.paginator.pageIndex,perpage,qString).subscribe((data:any) => {
        	this.length = parseInt(data.totaldata);
            this.loading = false;
            this.loaded = true;
            if(data.status)
            {
                this.doctorsList = data.data;
            }else{
                this.doctorsList = [];
            }
        }, error => {
            this.loading = false;
            this.loaded = true;
            this.sharedapi.checkError(error);
        });
    }

    pageChange(event)
    {
        this.pageIndex = event.pageIndex;
        this.loadDoctorsList(event.pageIndex,event.pageSize);
    }

    public getServerData(event:PageEvent):any
    {
        this.perpage = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.loadDoctorsList(event.pageIndex,event.pageSize);
    }

    async getcircle()
    {
        await this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
                this.circles_copy = this.circles;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getcity()
    {
        await this.leadapi.getcities().subscribe((data:any) => {
            if(data.status)
            {
                this.cities = data.data;
            }else{
                this.cities = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    exportDoctorList()
    {
        if(this.doctorsList.length>0)
        {
            let data = [];
            let titles = ['Profile Pic','Name', 'Email', 'Gender','Contact Number','Circle','City','Zone','Address','Qualification','Year of Experience',
            'Treatment Category',
            'Medical Speciality','Qualification Degree','Address Proof','Indemnity Bond','CV','Pan Card','Medical Registration Certificate','Cancelled cheque copy','Passport size photo','Glamyo Agreement','Status',
            'Past Work Experience',
            'Google Rating',
            'Practo Rating',
            'Pincode',
            'Latitude',
            'Longitude',
            'Featured Specialty',
            'Doctor Type',  
            'Glamyo Verified',
            'Language Spoken',
            'Location',
            'Services',
            'Localities',
            'Ranking',
            'Created on'];

            data.push(titles);
            for(let key in this.doctorsList)
            {
                let ProfilePic= 'Not Uploaded';
                if(this.doctorsList[key].image)
                ProfilePic= 'https://d1ov1jmwt3lnxf.cloudfront.net/'+this.doctorsList[key].image;
                let QualificationDegree= 'Not Uploaded';
                if(this.doctorsList[key].uploadedfiles[1].length)
                QualificationDegree= 'Uploaded';
                let Address= 'Not Uploaded';
                if(this.doctorsList[key].uploadedfiles[2].length)
                Address= 'Uploaded';
                let Indemnity= 'Not Uploaded';
                if(this.doctorsList[key].uploadedfiles[3].length)
                Indemnity= 'Uploaded';
                let CV= 'Not Uploaded';
                if(this.doctorsList[key].uploadedfiles[4].length)
                CV= 'Uploaded';
                let PanCard= 'Not Uploaded';
                if(this.doctorsList[key].uploadedfiles[5].length)
                PanCard= 'Uploaded';
                let MedicalCertificate= 'Not Uploaded';
                if(this.doctorsList[key].uploadedfiles[6].length)
                MedicalCertificate= 'Uploaded';
                let chequeCopy= 'Not Uploaded';
                if(this.doctorsList[key].uploadedfiles[7].length)
                chequeCopy= 'Uploaded';
                let PassportPhoto= 'Not Uploaded';
                if(this.doctorsList[key].uploadedfiles[8].length)
                PassportPhoto= 'Uploaded';
                let glamyoAgreement= 'Not Uploaded';
                if(this.doctorsList[key].uploadedfiles[9].length)
                glamyoAgreement= 'Uploaded';

                let Status;
                if(this.doctorsList[key].status=='0'){
                    Status='In-Active';
                }else if(this.doctorsList[key].status=='1'){
                    Status='Active';
                }else{
                    Status='Deleted';
                }

                let gendertext;
                if(this.doctorsList[key].gender == '1') {
                    gendertext = "Male";
                } else if(this.doctorsList[key].gender == '2') {
                    gendertext = "Female";
                } else {
                    gendertext = "NA";
                }

                let doc_zone = '';
                if(this.doctorsList[key].zone == '1') {
                    doc_zone = "East";
                } else if(this.doctorsList[key].zone == '2') {
                    doc_zone = "West";
                } else if(this.doctorsList[key].zone == '3') {
                    doc_zone = "North";
                } else if(this.doctorsList[key].zone == '4') {
                    doc_zone = "South";
                } else if(this.doctorsList[key].zone == '5') {
                    doc_zone = "Central";
                }

                let doctorType;
                if(this.doctorsList[key].doctor_type=='1'){
                    doctorType='Glamyo Doctor';
                }else if(this.doctorsList[key].doctor_type=='2'){
                    doctorType='Curify Doctor';
                }else if(this.doctorsList[key].doctor_type=='3'){
                    doctorType='Others';
                }else if(this.doctorsList[key].doctor_type=='4'){
                    doctorType='Glamyo Dental Doctor';
                }

                let glamyoVerified;
                if(this.doctorsList[key].is_glamyo_verified=='1'){
                    glamyoVerified='Yes';
                }else if(this.doctorsList[key].is_glamyo_verified=='0'){
                    glamyoVerified='No';
                }

                let exdata = [ProfilePic,this.doctorsList[key].name,
                this.doctorsList[key].email,
                gendertext,this.doctorsList[key].mobile,this.doctorsList[key].circle_name,this.doctorsList[key].cityName,
                doc_zone,
                this.doctorsList[key].address,
                this.doctorsList[key].qualification,this.doctorsList[key].work_exp,
                this.doctorsList[key].treatment_categories_name,
                this.doctorsList[key].specialist,QualificationDegree,Address,Indemnity,CV,PanCard,MedicalCertificate,chequeCopy,PassportPhoto,glamyoAgreement,Status,
                this.doctorsList[key].detail,
                this.doctorsList[key].google_rating,
                this.doctorsList[key].practo_rating,

                this.doctorsList[key].pincode,
                this.doctorsList[key].latitude,
                this.doctorsList[key].longitude,
                this.doctorsList[key].featured_specialty_name,
                doctorType,
                glamyoVerified,
                this.doctorsList[key].language_known,
                this.doctorsList[key].locations_name,
                this.doctorsList[key].services_name,
                this.doctorsList[key].locality,
                this.doctorsList[key].ranking,
                formatDate(this.doctorsList[key].created_at*1000, 'dd MMM, yyyy hh:mm aa', 'en-US')];

                data.push(exdata)
            }
            let ws = XLSX.utils.aoa_to_sheet(data);
           /* generate workbook and add the worksheet */
           const wb: XLSX.WorkBook = XLSX.utils.book_new();
           XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

           /* save to file */
           let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
           XLSX.writeFile(wb, 'doctor_'+utc+'.xlsx');
        }else{
            this.sharedapi.presentToast('Something went wrong, Try Again!');
        }
    }

    resetFilters()
    {
        this.search = ''; this.circle = ''; this.status = ''; this.treatment_category_filter = ''; this.zone = '';
        this.loadDoctorsList(0,25);
    }

    hideRankingStatusUpdateModal()
    {
        $('#myModalLeadStatusUpdate').modal('hide');
    }

    showRankingStatusUpdateModal()
    {
        $('#myModalLeadStatusUpdate').modal();
    }

    async rankingUpdate(event)
    {
        this.submitted = true;
        let file = event.target.files.item(0);
        const formData = new FormData();
        formData.append('file', file);
        this.doctorapi.uploadcsvDoctorRankingUpdate(formData)
        .subscribe((data:any) => {
            this.submitted = false;
            this.csvDoctorRankingFieldUpdate.nativeElement.value = "";
            if(data.status){
                this.sharedapi.presentToast(data.msg);
            }else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error =>
            {
                this.sharedapi.checkError(error);
            });
    }

  // ======csv for update doctor data============//
  hideModal() {
    this.uploaded_msg = '';
    $('#updateDataModal').modal('hide');
  }

  showModal() {
    this.uploaded_msg = '';
    $('#updateDataModal').modal();
  }

  async selectFile(event) {
    this.submitted = true;
    let file = event.target.files.item(0);
    const formData = new FormData();
    formData.append('file', file);
    this.uploaded_msg = "";
    this.doctorapi.uploadDoctorUpdateCsv(formData).subscribe((data: any) => {
      this.submitted = false;
      this.csvUpload.nativeElement.value = "";
      if (data.status) {
        this.uploaded_msg = data.msg;
      }
      else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }


}

